import { Outlet, Link } from "react-router-dom";

const Manufacturer = () => {

    return (
        <>
            <div id="sidebar" className="m-2">
                <nav className="m-2">
                    <ul className ="nav nav-tabs">
                        <li className="nav-item">
                            <Link className = "nav-link font-weight-bold" to={`viewManufacturerList`}>All Manufacturers</Link>
                        </li>
                        <li className="nav-item">
                            <Link className = "nav-link font-weight-bold" to={`addManufacturer`}>Add Manufacturer</Link>
                        </li>
                        {/* <li className="nav-item">
                            <Link className = "nav-link font-weight-bold" to={`manufacturerDetail`}>Manufacturer Detail</Link>
                        </li>
                        <li className="nav-item">
                            <Link className = "nav-link font-weight-bold" to={`editManufacturer`}>Edit Manufacturer</Link>
                        </li>*/} 
                    </ul>
                </nav>      
            </div>

            <div className="m-2">
                <Outlet />
            </div>
        </>
    )

}

export default Manufacturer